(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Header scroll state */
  const header = document.querySelector('[data-ad-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Drawer menu */
  const drawer = document.getElementById('AdMenu');
  const openers = document.querySelectorAll('[data-ad-menu-open]');
  let closeTimer;
  const openDrawer = () => {
    if (!drawer) return;
    clearTimeout(closeTimer);
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
    document.documentElement.classList.add('ad-lock');
    const btn = drawer.querySelector('button[data-ad-menu-close]');
    if (btn) btn.focus();
  };
  const closeDrawer = () => {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.documentElement.classList.remove('ad-lock');
    closeTimer = setTimeout(() => { drawer.hidden = true; }, 450);
    if (openers[0]) openers[0].focus();
  };
  openers.forEach((b) => b.addEventListener('click', openDrawer));
  if (drawer) drawer.querySelectorAll('[data-ad-menu-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* Auto-submit selects (sort, localization) */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-ad-autosubmit]') && e.target.form) e.target.form.submit();
  });

  /* Cart count */
  async function updateCartCount() {
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.querySelectorAll('[data-ad-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (_) {}
  }

  /* Product */
  document.querySelectorAll('[data-ad-product]').forEach((section) => {
    const form = section.querySelector('.ad-product__form');
    const dataEl = section.querySelector('[data-ad-variants]');
    if (!form || !dataEl) return;

    const variants = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('[data-ad-variant-id]');
    const btn = form.querySelector('[data-ad-add]');
    const label = form.querySelector('[data-ad-add-label]');
    const msg = form.querySelector('[data-ad-msg]');
    const priceEl = section.querySelector('[data-ad-price]');
    const gallery = section.querySelector('.ad-product__gallery');
    const fieldsets = [...form.querySelectorAll('[data-ad-option]')];
    const txt = { add: btn.dataset.addLabel, soldout: btn.dataset.soldoutLabel, unavailable: btn.dataset.unavailableLabel };
    let current = variants.find((v) => String(v.id) === idInput.value) || null;

    const renderPrice = (v) => {
      if (!priceEl) return;
      priceEl.textContent = '';
      if (v.compare) { const s = document.createElement('s'); s.textContent = v.compare; priceEl.append(s, ' '); }
      const span = document.createElement('span'); span.textContent = v.price; priceEl.append(span);
    };
    const setButton = () => {
      if (!current) { btn.disabled = true; label.textContent = txt.unavailable; return; }
      btn.disabled = !current.available;
      label.textContent = current.available ? txt.add : txt.soldout;
    };

    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-ad-option-input]')) return;
      const selected = fieldsets.map((fs) => { const i = fs.querySelector('input:checked'); return i ? i.value : null; });
      fieldsets.forEach((fs, i) => { const out = fs.querySelector('[data-ad-option-value]'); if (out) out.textContent = ' \u2014 ' + selected[i]; });
      current = variants.find((v) => v.options.every((o, i) => o === selected[i])) || null;
      setButton();
      msg.textContent = '';
      if (!current) return;
      idInput.value = current.id;
      renderPrice(current);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      history.replaceState({}, '', url);
      if (current.media && gallery) {
        const m = gallery.querySelector(`[data-media-id="${current.media}"]`);
        if (m) {
          if (window.matchMedia('(max-width: 989px)').matches) gallery.scrollTo({ left: m.offsetLeft, behavior: 'smooth' });
          else m.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!current || !current.available) return;
      btn.disabled = true;
      msg.textContent = '';
      try {
        const body = new FormData();
        body.append('id', idInput.value);
        body.append('quantity', '1');
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        msg.textContent = btn.dataset.addedLabel;
        await updateCartCount();
      } catch (err) {
        msg.textContent = err.message;
      } finally {
        setButton();
      }
    });
  });
})();
